import React, { useEffect, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { CustomModal } from "../../components";
import {
  useCreateLiveScoreMutation,
  useDeleteLiveScoreMutation,
  useFetchAllLiveScoresQuery,
  useFetchAllSportsQuery,
  useUpdateLiveScoreMutation,
  useFetchCollegesQuery,
} from "../../store/api/apiSlice";
import { Button as CustomBtn } from "../../ui";
const LiveScoresManagement = () => {
  const {
    data: liveScoresData = { live_scores: [] },
    isLoading,
    refetch,
  } = useFetchAllLiveScoresQuery();
  const { data: universitiesData } = useFetchCollegesQuery();
  const collegeList = universitiesData?.university || [];

  const { data: sportsData } = useFetchAllSportsQuery();
  const [createLiveScore] = useCreateLiveScoreMutation();
  const [updateLiveScore] = useUpdateLiveScoreMutation();
  const [deleteLiveScore] = useDeleteLiveScoreMutation();
  const [saveButton, setSaveButton] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [currentLiveScore, setCurrentLiveScore] = useState({
    schoolName: "",
    sportName: "",
    liveScore: "",
    latest: "",
    stats_url: "",
    highlights_url: "",
    next_details: "",
    nextscheduleURL: "",
  });

  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedSport, setSelectedSport] = useState(null);

  const baseUrl = process.env.REACT_APP_SERVER_URL || "";
  const secretKey = process.env.REACT_APP_SECRET_KEY || "";
  const [schoolError, setSchoolError] = useState(false);

  const openModal = () => setModalOpen(true);

  const closeModal = () => {
    setSaveButton(false);
    setModalOpen(false);
    setIsEditing(false);
    setSelectedSchool(null);
    setSelectedSport(null);
    setSchoolError(false);
    setCurrentLiveScore({
      schoolName: "",
      sportName: "",
      liveScore: "",
      latest: "",
      stats_url: "",
      highlights_url: "",
      next_details: "",
      nextscheduleURL: "",
    });
  };

  const openViewModal = async (id) => {
    const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token || "";
    const headers = {
      "secret-key": secretKey,
      "x-auth-token": xAuthToken,
    };

    try {
      const response = await fetch(
        `${baseUrl}/api/live-scores/get-single/${id}`,
        { headers }
      );
      if (response.ok) {
        const data = await response.json();
        setCurrentLiveScore(data.live_score);
        setViewModalOpen(true);
      } else {
        toast.error("Failed to fetch live score details.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching live score details.");
    }
  };
  const fetchScheduleURL = async (selectedSchool, selectedSport) => {
    if (!selectedSchool || !selectedSport) {
      return;
    }

    const xAuthToken = JSON.parse(localStorage.getItem("token"))?.token || "";
    const headers = {
      "Content-Type": "application/json",
      "secret-key": secretKey,
      "x-auth-token": xAuthToken,
    };

    const body = {
      university: selectedSchool.label,
      sports: selectedSport.label,
      gender: "",
    };

    try {
      const response = await fetch(
        `${baseUrl}/api/college-sport-schedule/filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(body),
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Fetched data:", data);

        if (data.schedule_data && data.schedule_data.length > 0) {
          const firstScheduleURL = data.schedule_data[0].schedule_url;
          setCurrentLiveScore((prev) => ({
            ...prev,
            nextscheduleURL: firstScheduleURL,
          }));
        } else {
          setCurrentLiveScore((prev) => ({
            ...prev,
            nextscheduleURL: "",
          }));
        }
      } else {
        toast.error("Failed to fetch URL.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching URL.");
    }
  };

  const closeViewModal = () => {
    setViewModalOpen(false);
    setCurrentLiveScore({
      schoolName: "",
      sportName: "",
      liveScore: "",
      latest: "",
      stats_url: "",
      highlights_url: "",
      next_details: "",
      nextscheduleURL: "",
    });
  };

  const handleCreateOrUpdate = async (e) => {
    setSaveButton(true);

    e.preventDefault();
    if (!selectedSchool) {
      setSchoolError(true);
      return;
    }
    const selectedSchoolId = selectedSchool.value;
    const selectedSportslId = selectedSport.value;

    const liveScoreData = {
      ...currentLiveScore,
      schoolName: selectedSchool ? selectedSchool.label : "",
      sportName: selectedSport ? selectedSport.label : "",
      school_id: selectedSchoolId,
      sportId: selectedSportslId,
    };

    try {
      let response;
      if (isEditing) {
        response = await updateLiveScore({
          id: currentLiveScore._id,
          liveScoreData,
        });
      } else {
        response = await createLiveScore(liveScoreData);
      }

      if (response?.data?.message) {
        setSaveButton(false);

        toast.success(response.data.message);
      }

      refetch();
      closeModal();
    } catch (error) {
      setSaveButton(false);

      toast.error("An error occurred while saving the live score.");
    }
  };

  const handleEdit = (liveScore) => {
    setCurrentLiveScore(liveScore);
    setSelectedSchool({
      value: liveScore.school_id,
      label: liveScore.schoolName,
    });
    setSelectedSport({ value: liveScore.sport_id, label: liveScore.sportName });
    setIsEditing(true);
    openModal();
  };

  const handleDelete = async (id) => {
    try {
      const response = await deleteLiveScore(id);

      if (response?.data?.message) {
        toast.success(response.data.message);
      }

      refetch();
    } catch (error) {
      toast.error("An error occurred while deleting the live score.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentLiveScore((prev) => ({ ...prev, [name]: value }));
  };

  const schoolOptions = collegeList.map((school) => ({
    value: school._id,
    label: school.name,
  }));

  const sportOptions =
    sportsData?.sports?.map((sport) => ({
      value: sport._id,
      label: sport.name,
    })) || [];

  if (isLoading) return <p>Loading...</p>;

  return (
    <div className="liveManagement_cont">
      <div className="liveManagement_cont2">
        <h3>Live Scores Management</h3>
        <Button
          variant="danger"
          className="liveManagement_createBtn"
          onClick={openModal}
        >
          Create Live Score
        </Button>
      </div>
      <Table striped bordered hover responsive className="live-scores-table">
        <thead>
          <tr>
            <th>School Name</th>
            <th>Sport Name</th>
            <th>Live Score</th>
            <th>Latest</th>
            <th>Stats URL</th>
            <th>Highlights URL</th>
            <th>Next Detail</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {liveScoresData.live_scores.map((score) => (
            <tr
              key={score._id}
              onClick={() => openViewModal(score._id)}
              style={{ cursor: "pointer" }}
            >
              <td>{score.schoolName}</td>
              <td>{score.sportName}</td>
              <td>{score.liveScore}</td>
              <td>{score.latest}</td>
              <td>
                <a
                  href={score.stats_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Stats
                </a>
              </td>
              <td>
                <a
                  href={score.highlights_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Highlights
                </a>
              </td>
              <td>{score.next_details}</td>
              <td>
                <div
                 className="admin_Actions_gap"
                >
                  <img
                    className="Update-delete-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(score);
                    }}
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios-glyphs/30/create-new.png"
                    alt="create-new"
                  />

                  <img
                    className="Update-delete-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(score._id);
                    }}
                    width="30"
                    height="30"
                    src="https://img.icons8.com/ios-glyphs/30/filled-trash.png"
                    alt="filled-trash"
                  />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <CustomModal isOpen={isViewModalOpen} onClose={closeViewModal}>
        <div style={{ padding: "1rem" }}>
          <h4>Live Score Details</h4>
          <p>
            <strong>School Name:</strong> {currentLiveScore?.schoolName}
          </p>
          <p>
            <strong>Sport Name:</strong> {currentLiveScore?.sportName}
          </p>
          <p>
            <strong>Live Score:</strong> {currentLiveScore?.liveScore}
          </p>
          <p>
            <strong>Latest:</strong> {currentLiveScore?.latest}
          </p>
          <p>
            <strong>Stats URL:</strong>{" "}
            <a
              href={currentLiveScore?.stats_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {currentLiveScore?.stats_url}
            </a>
          </p>
          <p>
            <strong>Highlights URL:</strong>{" "}
            <a
              href={currentLiveScore?.highlights_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {currentLiveScore?.highlights_url}
            </a>
          </p>
          <p>
            <strong>Next Detail:</strong> {currentLiveScore?.next_details}
          </p>

          <p>
            <strong>Next Schedule URL:</strong>{" "}
            <a
              href={currentLiveScore?.nextscheduleURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {currentLiveScore?.nextscheduleURL}
            </a>{" "}
          </p>
        </div>
      </CustomModal>

      <CustomModal
        isOpen={isModalOpen}
        onClose={closeModal}
        className="scrollable-modal"
      >
        <div className="advertisement_CreateModal">
          <h4
           className="liveManagement_create_title"
          >
            {isEditing ? "Edit Live Score" : "Create Live Score"}
          </h4>
          <Form onSubmit={handleCreateOrUpdate}>
            <Form.Group className="liveManagement_create_form">
              <Form.Label>School Name</Form.Label>

              <Select
                options={schoolOptions}
                value={selectedSchool}
                onChange={(option) => {
                  setSelectedSchool(option);
                  setSchoolError(false);
                  if (option && selectedSport) {
                    fetchScheduleURL(option, selectedSport);
                  }
                }}
                placeholder="Select School"
              />

              {schoolError && (
                <p className="liveManagement_school_error">School selection is required.</p>
              )}
            </Form.Group>
            <Form.Group className="liveManagement_create_form">
              <Form.Label>Sport Name</Form.Label>
              <Select
                options={sportOptions}
                value={selectedSport}
                onChange={(option) => {
                  setSelectedSport(option);
                  if (option && selectedSchool) {
                    fetchScheduleURL(selectedSchool, option);
                  }
                }}
                placeholder="Select Sport"
              />
            </Form.Group>
            <Form.Group className="liveManagement_create_form">
              <Form.Label>Next Schedule URL</Form.Label>
              <Form.Control
                name="nextscheduleURL"
                value={currentLiveScore.nextscheduleURL}
                onChange={handleChange}
                placeholder="Next Schedule URL"
              />
            </Form.Group>

            <Form.Group className="liveManagement_create_form">
              <Form.Label>Live Score</Form.Label>
              <Form.Control
                name="liveScore"
                value={currentLiveScore.liveScore}
                onChange={handleChange}
                placeholder="Live Score"
              />
            </Form.Group>
            <Form.Group className="liveManagement_create_form">
              <Form.Label>Latest</Form.Label>
              <Form.Control
                name="latest"
                value={currentLiveScore.latest}
                onChange={handleChange}
                placeholder="Latest Score"
              />
            </Form.Group>
            <Form.Group className="liveManagement_create_form">
              <Form.Label>Stats URL</Form.Label>
              <Form.Control
                name="stats_url"
                value={currentLiveScore.stats_url}
                onChange={handleChange}
                placeholder="Stats URL"
              />
            </Form.Group>
            <Form.Group className="liveManagement_create_form">
              <Form.Label>Highlights URL</Form.Label>
              <Form.Control
                name="highlights_url"
                value={currentLiveScore.highlights_url}
                onChange={handleChange}
                placeholder="Highlights URL"
              />
            </Form.Group>
            <Form.Group className="liveManagement_create_form">
              <Form.Label>Next Detail</Form.Label>
              <Form.Control
                name="next_details"
                value={currentLiveScore.next_details}
                onChange={handleChange}
                placeholder="Next Detail"
              />
            </Form.Group>

            <div className="liveManagement_saveBtn_cont">
              <CustomBtn
                loading={saveButton}
                type="submit"
                variant="primary"
                style={{ marginTop: "15px" }}
              >
                {isEditing ? "Update" : "Create"}
              </CustomBtn>
            </div>
          </Form>
        </div>
      </CustomModal>
    </div>
  );
};

export default LiveScoresManagement;
